import styles from "./style.module.scss";

const getGridClassName = (row) => {
    let className;

    switch (row.length) {
        case 1:
            className = "fullWidthInputContainer";
            break;
        case 2:
            className = "halfWidthInputContainer";
            break;
        case 3:
            className = "thirdWidthInputContainer";
            break;
        default:
            className = "";
            break;
    }

    return styles[className];
}

export default getGridClassName;